import styled from "@emotion/styled";
import { fadeIn } from "../style/ani";
import { FadeInContent } from "./FadeInContent";

const ImageWrapper = styled.div`
  background-image: url(/selected/GWA02216.jpeg);
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  padding-top: 40px;
  height: 767px;
  /* max-height: 100vh; */
  width: 100%;
   @media (max-width: 748px) {
    /* height: -webkit-fill-available;
    height: fill-available;
    height: calc(var(--vh, 1vh) * 100); */
    height: 700px;
  }
`;

const Container = styled.div`
  width: 100%;
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export function Parent() {
  return (
    <Container>
      <ImageWrapper>
        <Texts>
          <span>
              차준경 · 안연희의 막둥이 <strong>차이새</strong>
          </span>
          <span>
              김성우 · 이은경의 막둥이 <strong>김민지</strong>
          </span>
          저희 결혼합니다 ❤️

          <div
            style={{
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
          </div>
        </Texts>

      </ImageWrapper>
    </Container>
  );
}
